import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { AdminLessonListVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";
import { adminRetrieveLessons } from "./retrieve-lessons";

const initialState: RetrievalState<PaginatedResult<AdminLessonListVM>> = {
  fetching: "idle",
  data: {
    items: [],
    page: 1,
    pageSize: 50,
    total: 0,
    totalPages: 0,
  },
};

export const adminRetrieveLessonsReducer = createReducer<RetrievalState<PaginatedResult<AdminLessonListVM>>>(initialState, builder => {
  builder.addCase(adminRetrieveLessons.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(adminRetrieveLessons.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(adminRetrieveLessons.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
